import React, { useEffect } from 'react';

import { Route, Routes } from 'react-router-dom';

// Import Routes all
import { userRoutes, authRoutes } from './routes/allRoutes';

// Import all middleware
import Authmiddleware from './routes/middleware/Authmiddleware';

// layouts Format
import VerticalLayout from './components/VerticalLayout/';
import { NonAuthLayout } from './components/NonAuthLayout';

// Import scss
import './assets/scss/theme.scss';
import 'react-image-crop/src/ReactCrop.scss';

import { getConfigFromStorage } from './utils/config';
import { AdminConfigService } from './services';
import { useGetConfig } from './services/queries/admin-config';

const App = () => {
  const { data: config } = useGetConfig();

  useEffect(() => {
    const checkSession = () => {
      const configStorage = getConfigFromStorage();
      if (!configStorage) {
        AdminConfigService.setConfig();
      }
    };
    checkSession();
    window.addEventListener('configChange', checkSession);
    return () => {
      window.removeEventListener('configChange', checkSession);
    };
  }, []);

  if (config?.favicon) {
    const link = (document.querySelector("link[rel*='icon']") as HTMLLinkElement) || document.createElement('link');
    link.id = 'favicon';
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = config?.favicon;
    document.head.appendChild(link);
  } else {
    const link = document.getElementById('favicon');
    if (link) {
      link.remove();
    }
  }

  return (
    <React.Fragment>
      <Routes>
        <Route>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={<NonAuthLayout>{route.component}</NonAuthLayout>} key={idx} />
          ))}
        </Route>

        <Route>
          {userRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <Authmiddleware>
                  <VerticalLayout>{route.component}</VerticalLayout>
                </Authmiddleware>
              }
              key={idx}
            />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default App;
